import React, { Component } from "react";
import { Helmet } from "react-helmet";
import EmptyImg from "../Dashboard/assets/img/signupDone.gif";
import { Link } from "react-router-dom";
import LoginSignupMessage from "./siteComponents/LoginSignupMessage";
import logo from "../Dashboard/assets/img/logo.png";
import { HOST_URL, NODE_HOST_URL } from "../Dashboard/api/Api";
import Axios from "axios";
class ForgotPassword extends Component {
  constructor() {
    const url2 = document.location.href;
    super();
    this.state = {
      url: url2,
      email: "",
      otp: "",
      newPassword: "",
      confirmPassword: "",
      otpSent: false,
      errorMessage: "",
      successMessage: false,
      forgotScreen: true,
      bgColor: "alert alert-success alert-dismissible",
    };
  }

  sendOtp = async (e) => {
    e.preventDefault(); // ✅ prevent form reload
    if (!this.state.email) {
      alert("Please enter your registered email.");
      return;
    }

    try {
      const { data } = await Axios.post(`${NODE_HOST_URL}/forgot_password`, {
        method: "email_otp",
        email: this.state.email,
      });

      if (data?.success) {
        this.setState({ otpSent: true }); // ✅ correct key
      } else {
        alert(data?.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      alert("Failed to send OTP. Please try again.");
    }
  };


  // ✅ METHOD: Handle Update Password
  updatePassword = async (e) => {
    e.preventDefault();

    const { email, otp, newPassword, confirmPassword } = this.state;

    // ✅ Log all fields
    console.log("🔍 Form values:", {
      email,
      otp,
      newPassword,
      confirmPassword,
    });

    //  Basic validation
    if (!email || !otp || !newPassword || !confirmPassword) {
      this.setState({
        errorMessage: "All fields are required.",
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      this.setState({
        errorMessage: "Passwords do not match.",
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }

    //  Password policy enforcement
    const passwordPolicyRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordPolicyRegex.test(newPassword)) {
      this.setState({
        errorMessage:
          "Password must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character.",
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
      });
      return;
    }


    try {
    
      const { data } = await Axios.post(`${NODE_HOST_URL}/forgot_password`, {
        method: "user_forgot_password",
        email: this.state.email,
        otp: this.state.otp,
        new_password: this.state.newPassword,
      });

      this.setState({
        errorMessage: data.message,
        successMessage: true,
        bgColor: data.success
          ? "alert alert-success alert-dismissible"
          : "alert alert-danger alert-dismissible",
        forgotScreen: !data.success,
      });

    } catch (error) {
      this.setState({
        errorMessage: "Something went wrong. Please try again later.",
        successMessage: true,
        bgColor: "alert alert-danger alert-dismissible",
      });
    }
  };

  // forgotPassword() {
  //   this.setState({ successMessage: false });
  //   fetch(`${HOST_URL}/forgot_password.php`, {
  //     method: "post",
  //     headers: {
  //       "content-Type": "application/json",
  //     },
  //     body: JSON.stringify(this.state),
  //   }).then((result) => {
  //     result.json().then((resp) => {
  //       console.log(resp);
  //       if (resp.success === true) {
  //         this.setState({
  //           successMessage: true,
  //           forgotScreen: false,
  //           bgColor: "alert alert-success alert-dismissible",
  //           errorMessage: resp.message,
  //         });
  //       } else {
  //         this.setState({
  //           successMessage: true,
  //           forgotScreen: true,
  //           bgColor: "alert alert-danger alert-dismissible",
  //           errorMessage: resp.message,
  //         });
  //       }
  //     });
  //   });
  // }

  render() {
    return (
      <div>
        <Helmet>
          <title>
            Get register for free plan to Send SMS Email Voice Using one API -
            AuthKey.io
          </title>
          <meta
            name="description"
            content="Free plan for SMS voice Email API to send parallelly or use other channels as Fallback | High Volume APIs Built for Sending huge volume. Get free signup"
          />
        </Helmet>

        <section style={{ background: "#fff" }} className="loginbg">
          <div className="d-flex flex-column">
            <div className="row justify-content-center min-vh-100">
              <div className="col-md-6 col-lg-6 col-xl-6 ">
                <div className="login-new-box">
                  <form className="form-row col-md-8  pr-md-5 pr-sm-0">
                    <div className="form-group col-md-12">
                      {this.state.successMessage ? (
                        <div className={this.state.bgColor} role="alert">
                          <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">×</span>
                          </button>
                          <div className="">{this.state.errorMessage}</div>
                        </div>
                      ) : null}
                    </div>

                    <div className=" form-group col-md-12">
                      <div className="">
                        {this.state.forgotScreen ? (
                          <>
                            <div className="mb-3">
                              {this.state.url === 'https://auth.promotionmantra.com/forgot-password' ? null :
                                <Link to="/">
                                  <img
                                    className="img-fluid w-50 mb-3"
                                    alt="forget Password"
                                    src={logo}
                                  />
                                </Link>}
                              <h6 className="h3">Forgot Password</h6>
                              <p className="text-muted mb-0">
                                Enter Your Register Email to Send New Password
                              </p>
                            </div>

                            <div className="form-group">
                              <div className="form-group">
                                <input
                                  type="text"
                                  required
                                  name="username"
                                  onChange={(event) =>
                                    this.setState({ email: event.target.value })
                                  }
                                  className="form-control"
                                  placeholder="name@example.com"
                                />
                                {!this.state.otpSent && (
                                  <button className="home-button btn-signup w-100 mt-2" onClick={(e) => this.sendOtp(e)}>
                                    Send OTP
                                  </button>

                                )}
                              </div>
                            </div>

                            {this.state.otpSent && (
                              <div className="form-group mb-3">
                                {/* ✅ OTP Input */}
                                <label>Enter OTP</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter OTP"
                                  value={this.state.otp}
                                  onChange={(e) => this.setState({ otp: e.target.value })}
                                />

                                {/* ✅ New Password Input */}
                                <label className="mt-3">New Password</label>
                                <input
                                  type="password"
                                  className="form-control"
                                  placeholder="Enter new password"
                                  value={this.state.newPassword}
                                  onChange={(e) => this.setState({ newPassword: e.target.value })}
                                />

                                {/* ✅ Confirm Password Input */}
                                <label className="mt-3">Confirm Password</label>
                                <input
                                  type="password"
                                  className="form-control"
                                  placeholder="Confirm password"
                                  value={this.state.confirmPassword}
                                  onChange={(e) => this.setState({ confirmPassword: e.target.value })}
                                />

                                {/* ✅ Update Password Button */}
                                <button
                                  className="btn btn-primary mt-3"
                                  onClick={this.updatePassword}
                                >
                                  Update Password
                                </button>
                              </div>
                            )}

                            {!this.state.forgotScreen && (
                              <div className="text-center">
                                <img alt="Empty Data" style={{ width: "100px" }} src={EmptyImg} />
                                <p>
                                  We have sent a new password to <strong>{this.state.email}</strong>.
                                </p>
                                <Link className="btn btn-primary btn-sm" to="login">Go To Login</Link>
                              </div>
                            )}


                            <div className="d-flex mt-3 justify-content-between">
                              <p className="small">
                                <Link to="/signup?ref=signup">
                                  Don't have account ?
                                </Link>
                              </p>
                              <p className="Forgot">
                                <Link to="/login">Login </Link>
                              </p>
                            </div>

                          </>
                        ) : (
                          <div className="text-center">
                            <img
                              alt="Empty Data"
                              style={{ width: "100px" }}
                              src={EmptyImg}
                            />
                            <p>
                              Your password has been updated successfully for <strong>{this.state.email}</strong>. Please use your new password to log in.
                            </p>
                            <Link className="btn btn-primary btn-sm" to="login">
                              Go To Login
                            </Link>
                          </div>

                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              {this.state.url === 'https://auth.promotionmantra.com/forgot-password' ? null : <LoginSignupMessage />}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default ForgotPassword;
